export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./rules.vue?vue&type=template&id=5c7b77e4"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/rules/rules.vue?vue&type=template&id=5c7b77e4
// module id = 0gtl
// module chunks = 0